import UserProfile from "../Context/UserProfile";
import "./Blogs.css";
import { useEffect, useState } from "react";
const BlogList = ({ setUserName,setPageTitle }) =>
{
    const [displayName, setDisplayName] = useState();
    useEffect(() => {
        setUserName(UserProfile.getName());
        setDisplayName(UserProfile.getName());
        if(UserProfile.getLoginStatus()==="1"){
			setPageTitle("Blogs");
		}
    }, []);
    return (
        <>
            <div className={displayName && displayName.length>0?"main-content":""}>
                {UserProfile.getLoginStatus()!=="1" && <><header>
						<div className="header-container">
							<div className="logo">
								<a style={{ textDecoration: "none" }} href="/">
									<span style={{ color: 'white' }}>Contr
										<span style={{ color: "#ff8400" }}>e</span>
										ct</span>
								</a>

							</div>
							<nav><a href="/Signup" className="btn btn-success">Sign In</a>
							</nav>
						</div>
					</header>
					<div style={{ paddingTop: '20px', paddingLeft: '20px' }}>
						<h1>Blogs</h1>
						<span className="effective-date">Last Updated: 3 December 2025</span>
					</div></>}
                <div className="blog-container">
                    
                    <ul>
                        <li><a href="/Blog1">Why Businesses Need Structured Contracts?</a></li>
                        <li><a href="/Blog2">The Real Cost of Unstructured Contracts in Business</a></li>
                        
                    </ul>

                </div>
            </div>
            
            
        </>
    );
};
export default BlogList;